import React, { useEffect, useState } from "react";
import { useField } from "react-final-form";
import {
  BooleanInput,
  FormDataConsumer,
  maxValue,
  minValue,
  NumberInput,
  required,
  useDataProvider,
} from "react-admin";
import { Grid } from "@material-ui/core";
import { StudentResources } from "utils/tools";
import EditSubsidyPercentageButton from "./EditSubsidyPercentageButton";
import ShowStudentSubsidyHistoryButton from "./ShowStudentSubsidyHistoryButton";
import SanitizedGrid from "../../../components/SanitizedGrid";

interface IStudentSubsidyProps {
  studentId: number;
}

const StudentSubsidyInput = ({ studentId }: IStudentSubsidyProps) => {
  const [school, setSchool] = useState<ISchool>(null);
  const [activeStudentSubsidy, setActiveStudentSubsidy] =
    useState<IStudentSubsidy>(null);
  const [isDisabled, setIsDisabled] = useState<boolean>(true);

  const studentResources = StudentResources(Number(studentId));
  const provider = useDataProvider();

  const isApplyStudentSubsidyField = useField("isApplyStudentSubsidy");
  const subsidyPercentageField = useField("subsidyPercentage");

  useEffect(() => {
    isApplyStudentSubsidyField.input.onChange(false);
    subsidyPercentageField.input.onChange("");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentId]);

  useEffect(() => {
    if (studentResources && studentResources.schoolId) {
      provider
        .getOne("schools", {
          id: Number(studentResources.schoolId),
        })
        .then(({ data }) => {
          setSchool(data as ISchool);
        });
    }

    if (studentResources && studentResources.activeStudentSubsidyId) {
      provider
        .getOne(`studentSubsidies`, {
          id: studentResources.activeStudentSubsidyId,
        })
        .then(({ data }) => {
          setActiveStudentSubsidy(data as IStudentSubsidy);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentResources]);

  useEffect(() => {
    if (isApplyStudentSubsidyField.input.value) {
      subsidyPercentageField.input.onChange(
        activeStudentSubsidy?.subsidyPercentage || 0,
      );
    } else {
      subsidyPercentageField.input.onChange("");
    }

    setIsDisabled(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isApplyStudentSubsidyField.input.value]);

  return (
    <FormDataConsumer>
      {({ formData }) =>
        school &&
        school?.isStudentSubsidyEnable && (
          <>
            <Grid item xs={4} style={{ marginTop: "-15px" }}>
              <BooleanInput
                source="isApplyStudentSubsidy"
                label="Apply Student Subsidy"
                defaultValue={false}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            {formData.isApplyStudentSubsidy && (
              <Grid
                item
                xs={4}
                style={{ marginTop: "-40px", marginBottom: "30px" }}
              >
                <SanitizedGrid container alignItems="center" spacing={1}>
                  <Grid item xs={6}>
                    <NumberInput
                      source="subsidyPercentage"
                      label="Subsidy Percentage (%)"
                      validate={[required(), minValue(0), maxValue(100)]}
                      disabled={isDisabled}
                    />
                  </Grid>
                  {isDisabled && (
                    <Grid item>
                      <EditSubsidyPercentageButton
                        onConfirmEdit={() => {
                          setIsDisabled(false);
                        }}
                      />
                    </Grid>
                  )}
                  {studentResources && (
                    <Grid item>
                      <ShowStudentSubsidyHistoryButton
                        studentId={studentId}
                        activeStudentSubsidyId={
                          studentResources.activeStudentSubsidyId
                        }
                      />
                    </Grid>
                  )}
                </SanitizedGrid>
              </Grid>
            )}
          </>
        )
      }
    </FormDataConsumer>
  );
};

export default StudentSubsidyInput;
